<template>
  <div>
    <div class="serach-box" v-if="activeRole && showList === false">
      <div class="w-50 m-auto">
        <b-form-input
          v-model="orgName"
          :placeholder="'请输入完整' + activeRole + '名称'"
        ></b-form-input>
      </div>
      <div class="w-50 mx-auto my-3 d-flex">
        <b-form-input
          v-model="codeInput"
          placeholder="输入图片中的字符"
        ></b-form-input>
        <img-code class="ml-1" @change="code = $event"></img-code>
      </div>
      <div class="m-auto" style="width: 50%">
        <button
          type="button"
          :disabled="!orgName || onSearch"
          class="btn btn-primary mt-3 w-25 mr-2"
          @click="toSearch"
        >
          确定
        </button>
        <button
          type="button"
          class="btn mt-3 w-25"
          @click="
            activeRole = null;
            codeInput = '';
            orgName = '';
          "
        >
          返回
        </button>
      </div>
    </div>
    <div class="list-box" v-else-if="showList === true">
      <div class="list-wrap">
        <b-table
          striped
          bordered
          fixed
          responsive
          hover
          small
          :items="list"
          :fields="curRole.colsMap"
          tdClass="td"
        ></b-table>
      </div>
      <div class="m-auto">
        <button
          type="button"
          class="btn btn-primary mt-3 w-25"
          @click="showList = false"
        >
          返回
        </button>
      </div>
    </div>
    <template v-else>
      <div class="select-role">
        <div
          class="role-item"
          v-for="item in roles"
          @click="activeRole = item.name"
          :key="item.name"
        >
          我是{{ item.name }}
        </div>
      </div>
      <button class="btn btn-primary mt-3 w-25" @click="$emit('cancel')">
        返回
      </button>
    </template>
  </div>
</template>

<script>
import { getAccountInfo } from "@/api/api";
import imgCode from "./validateImageCode.vue";

export default {
  components: {
    imgCode,
  },
  props: {
    activeNav: {
      type: Object,
    },
  },
  data() {
    function paramsMatter(value, row, index) {
      // var values = value;
      // values = values.replace(/\s+/g, '&nbsp;')//替换空格
      // values = values.replace(/\},/, '},\n');//换行
      // var span = document.createElement('span');
      // span.setAttribute('title', values);
      // span.innerHTML = value;
      return value;
      // return span.outerHTML;
    }
    return {
      code: "",
      codeInput: "",
      onSearch: false,
      showList: false,
      activeRole: null,
      orgName: "",
      roles: [
        {
          name: "教育局",
          service: "srvledu_bureau_online_select",
          nameCol: "bu_name",
          colsMap: [
            // {
            //   label: "教育局编号",
            //   key: "bu_no",
            // },
            {
              label: "教育局名称",
              key: "bu_name",
            },
            {
              label: "级别",
              key: "level",
            },
            {
              label: "归属教育局名称",
              key: "be_to_bu_name",
            },

            {
              label: "联系人名称",
              key: "_contact_name",
              // key: "contact_name",
            },
            {
              label: "联系人手机",
              key: "_phone_no",
              // key: "phone_no",
            },
            {
              label: "详细地址",
              key: "address",
            },
            // {
            //   label: "创建时间",
            //   key: "create_time",
            // },
          ],
        },
        {
          name: "学校",
          service: "srvledu_school_online_select",
          nameCol: "school_name",
          colsMap: [
            {
              label: "学校编码",
              key: "school_no",
            },
            {
              label: "学校名称",
              key: "school_name",
            },
            {
              label: "归属教育局",
              key: "bu_name",
            },
            {
              label: "详细地址",
              key: "school_place",
            },
            {
              label: "教育阶段",
              key: "stage",
            },
            {
              label: "联系人姓名",
              key: "contact_name",
            },
            {
              label: "联系人手机",
              key: "phone_no",
            },
          ],
        },
        {
          name: "基地",
          service: "srvledu_practice_base_online_select",
          nameCol: "jdmc",
          colsMap: [
            {
              label: "基地编号",
              key: "jd_no",
            },
            {
              label: "基地名称",
              key: "jdmc",
            },
            {
              label: "公布批次",
              key: "pub_batch",
            },
            {
              label: "是否已上目录",
              key: "up_directory",
            },
            {
              label: "所在区域",
              key: "szqy",
            },
            {
              label: "基地联系人",
              key: "jdlxr",
            },
            {
              label: "联系人电话",
              key: "jdlxrdh",
            },
            {
              label: "基地级别",
              key: "jdjb",
            },
            {
              label: "详细地址",
              key: "txdz",
            },
            {
              label: "状态",
              key: "state",
            },
            {
              label: "创建时间",
              key: "create_time",
            },
          ],
        },
        {
          name: "机构",
          service: "srvledu_org_online_select",
          nameCol: "name",
          colsMap: [
            {
              label: "机构编码",
              key: "no",
              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
            {
              label: "机构名称",
              key: "name",
              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
            {
              label: "公司名称",
              key: "gsmc",
              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
            {
              label: "状态",
              key: "state",
              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
            // {
            //   label: "机构类型",
            //   key: "org_type",
            //   tdAttr: (value) => {
            //     return {
            //       title: value,
            //     };
            //   },
            // },
            // {
            //   label: "统一信用社会代码",
            //   key: "bus_license",
            //   tdAttr: (value) => {
            //     return {
            //       title: value,
            //     };
            //   },
            // },
            {
              label: "成立日期",
              key: "establish_date",
              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
            {
              label: "注册地点",
              key: "reg_address",
              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
            {
              label: "联系人",
              key: "contact_name",

              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
            {
              label: "联系电话",
              key: "phone_no",
              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
            {
              label: "创建时间",
              key: "create_time",
              tdAttr: (value) => {
                return {
                  title: value,
                };
              },
            },
          ],
        },
      ],
      list: [],
      page: {},
    };
  },
  computed: {
    curRole() {
      return this.roles.find((item) => item.name === this.activeRole);
    },
    codeIsValid() {
      const code = this.code?.toLowerCase();
      const codeInput = this.codeInput?.toLowerCase();
      return code && codeInput === code;
    },
  },
  methods: {
    toSearch() {
      if (!this.codeInput) {
        return alert("请输入验证码!");
      }
      if (!this.codeIsValid) {
        return alert("验证码错误!");
      }
      this.codeInput = "";
      getAccountInfo(
        this.curRole.service,
        this.curRole.nameCol,
        this.orgName
      ).then((res) => {
        if (res.state === "SUCCESS") {
          this.list = res.data.map((item) => {
            const obj = {
              ...item,
            };
            if (item.phone_no) {
              item.phone_no = item.phone_no + "";
              obj._phone_no = item.phone_no
                .slice(0, item.phone_no.length - 4)
                .padEnd(item.phone_no.length, "*");
            }
            if (item.contact_name) {
              obj._contact_name = item.contact_name[0].padEnd(
                item.contact_name.length,
                "*"
              );
            }
            return obj;
          });
          this.page = res.page;
          if (res.data.length === 0) {
            alert("未查到相关数据");
            this.showList = false;
          } else {
            this.showList = true;
          }
        } else if (res?.resultMessage) {
          alert(res.resultMessage);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-box {
  margin-top: 10vh;
}

.select-role {
  // display: flex;
  // flex-wrap: wrap;
  max-width: 800px;
  margin: 10vh auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.role-item {
  cursor: pointer;
  background-color: #0e77ea;
  color: #fff;
  flex: 1;
  min-width: 100px;
  margin-right: 1rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
  height: 100px;
  line-height: 100px;
}

.list-wrap {
  // min-width: 800px;
  // overflow-x: auto;
  max-width: 1600px;
  margin: 20px auto;
  ::v-deep td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
